// Simple example of a React "smart" component

import { connect } from 'react-redux';
import WebOrderForm from '../components/WebOrderForm';
import * as actions from '../actions/webOrderFormActionCreators';

// Which part of the Redux global state does our component want to receive as props?
const mapStateToProps = (state) => ({
  team: state.team,
  csrfToken: state.csrfToken,
  revealedHold: state.revealedHold,
  confirm: state.confirm,
  ticketTypes: state.ticketTypes,
  promoCode: state.promoCode,
  promoCodeName: state.promoCodeName,
  promoCodeNameValid: state.promoCodeNameValid,
  promoCodeInvalidReason: state.promoCodeInvalidReason,
  ticketReservation: state.ticketReservation,
  stripePromise: state.stripePromise,
  stripePublishableKey: state.stripePublishableKey,
  stripeConnectedAccountId: state.stripeConnectedAccountId,
  stripeError: state.stripeError,
  rootUrl: state.rootUrl,
  checkoutTimePercentageRemaining: state.checkoutTimePercentageRemaining,
  timeLimitReached: state.timeLimitReached,
  isPlacingOrder: state.isPlacingOrder,
  addOns: state.addOns,
  googleTrackingIds: state.googleTrackingIds,
  gtag: state.gtag,
  customFieldValues: state.customFieldValues,
  userContext: state.userContext,
  attributionVisitorUuid: state.attributionVisitorUuid,
  seatsIOPublicKey: state.seatsIOPublicKey,
  seatsIOChart: state.seatsIOChart,
  seatsIOSelectedObjects: state.seatsIOSelectedObjects,
  customerioId: state.customerioId,
  parentUrl: state.parentUrl,
  checkoutToken: state.checkoutToken,
  isCreatingTicketReservation: state.isCreatingTicketReservation,
  cartStartBusyMessage: state.cartStartBusyMessage,
  verticalInsureClientID: state.verticalInsureClientID,
  insuranceOfferState: state.insuranceOfferState,
  ticketInsurance: state.ticketInsurance,
  hasInsuranceQuote: state.hasInsuranceQuote,
  announceListEnabled: state.announceListEnabled,
  waitlistEnabled: state.waitlistEnabled,
  donationCustomChargeType: state.donationCustomChargeType,
  feeRules: state.feeRules,
  startAtAddOns: state.startAtAddOns,
  ticketsSoldElsewhere: state.ticketsSoldElsewhere,
  startAtDonation: state.startAtDonation,
  showHeader: state.showHeader,
  showCheckoutDate: state.showCheckoutDate,
  checkoutCategories: state.checkoutCategories,
  restrictedTicketTypeId: state.restrictedTicketTypeId,
  restrictedTicketGroupId: state.restrictedTicketGroupId,
  entryTimeLabel: state.entryTimeLabel,
  seriesReturnUrl: state.seriesReturnUrl,
  ticketGroups: state.ticketGroups,
  verb: state.verb,
  membershipProducts: state.membershipProducts,
  selectedMembershipProduct: state.selectedMembershipProduct,
  widgetConfig: state.widgetConfig,
  widgetType: state.widgetType,
  adminPreview: state.adminPreview,
  useDefaultTheme: state.useDefaultTheme,
  widgetTemplateId: state.widgetTemplateId,
  resaleListings: state.resaleListings,
  resaleOrderItems: state.resaleOrderItems,
});

const mapDispatchToProps = (dispatch) => {
  return {
    confirmChanged: (confirm) => dispatch(actions.confirmChanged(confirm)),
    channelMsgReceived: (calculatorRef) => (data) => dispatch(actions.channelMsgReceived(calculatorRef)(data)),
    lookupPromoCode: (confirm, name, ticketTypes, csrfToken, addOns, ticketReservation, userContext) => dispatch(actions.lookupPromoCode(dispatch, confirm, name, ticketTypes, csrfToken, addOns, ticketReservation, userContext)),
    promoCodeNameChanged: (name) => dispatch(actions.promoCodeNameChanged(name)),
    promoCodeChanged: (promoCode) => dispatch(actions.promoCodeChanged(promoCode)),
    ticketTypesChanged: (ticketTypes) => dispatch(actions.ticketTypesChanged(ticketTypes)),
    buildTicketReservation: (csrfToken, confirm, ticketTypes, promoCode, addOns, ticketReservation, userContext) => dispatch(actions.buildTicketReservation(dispatch, csrfToken, confirm, ticketTypes, promoCode, addOns, ticketReservation, userContext)),
    ticketReservationChanged: (ticketReservation) => dispatch(actions.ticketReservationChanged(ticketReservation)),
    createTicketReservation: (csrfToken, confirm, ticketTypes, promoCode, addOns, ticketReservation, seatsIOChart, customerioId, userContext, parentUrl) => dispatch(actions.createTicketReservation(dispatch, csrfToken, confirm, ticketTypes, promoCode, addOns, ticketReservation, seatsIOChart, customerioId, userContext, parentUrl)),
    deleteTicketReservation: (csrfToken, confirm, ticketReservation) => dispatch(actions.deleteTicketReservation(dispatch, csrfToken, confirm, ticketReservation)),
    stripePromiseChanged: (stripePromise) => dispatch(actions.stripePromiseChanged(stripePromise)),
    stripeErrorChanged: (error) => dispatch(actions.stripeErrorChanged(error)),
    updateTicketReservation: (csrfToken, confirm, ticketReservation, onSuccess, customFieldValues, acceptedVenueAgreementIds, resaleTermsAccepted) => dispatch(actions.updateTicketReservation(dispatch, csrfToken, confirm, ticketReservation, onSuccess, customFieldValues, acceptedVenueAgreementIds, resaleTermsAccepted)),
    checkoutTimePercentageRemainingChanged: (percentage) => dispatch(actions.checkoutTimePercentageRemainingChanged(percentage)),
    timeLimitReachedChanged: (reached) => dispatch(actions.timeLimitReachedChanged(reached)),
    isPlacingOrderChanged: (isPlacingOrder) => dispatch(actions.isPlacingOrderChanged(isPlacingOrder)),
    cartStartBusyMessageChanged: (message) => dispatch(actions.cartStartBusyMessageChanged(message)),
    addOnsChanged: (addOns) => dispatch(actions.addOnsChanged(addOns)),
    gtagChanged: (gtag) => dispatch(actions.gtagChanged(gtag)),
    customFieldValueChanged: (customFieldValue) => dispatch(actions.customFieldValueChanged(customFieldValue)),
    cancelCheckout: () => dispatch(actions.cancelCheckout()),
    seatsIOChartChanged: (seatsIOChart) => dispatch(actions.seatsIOChartChanged(seatsIOChart)),
    seatsIOSelectedObjectsChanged: (seatsIOSelectedObjects) => dispatch(actions.seatsIOSelectedObjectsChanged(seatsIOSelectedObjects)),
    autoSaveTicketReservation: (csrfToken, confirm, ticketReservation) => dispatch(actions.autoSaveTicketReservation(dispatch, csrfToken, confirm, ticketReservation)),
    customerioIdChanged: (customerioId) => dispatch(actions.customerioIdChanged(customerioId)),
    parentUrlChanged: (parentUrl) => dispatch(actions.parentUrlChanged(parentUrl)),
    originAttributionChanged: (originAttribution) => dispatch(actions.originAttributionChanged(originAttribution)),
    metaClickIdChanged: (metaClickId) => dispatch(actions.metaClickIdChanged(metaClickId)),
    attributionVisitorChanged: (attributionVisitorUuid) => dispatch(actions.attributionVisitorChanged(attributionVisitorUuid)),
    reportParentUrlForUtmBeacon: (confirmId) => dispatch(actions.reportParentUrlForUtmBeacon(confirmId)),
    saveGeoCodedStateCode: (csrfToken, confirm, ticketReservation, stateCode) => dispatch(actions.saveGeoCodedStateCode(dispatch, csrfToken, confirm, ticketReservation, stateCode)),
    registerTicketInsurance: (csrfToken, confirm, ticketReservation, quote) => dispatch(actions.registerTicketInsurance(dispatch, csrfToken, confirm, ticketReservation, quote)),
    insuranceOfferStateChanged: (insuranceOfferState) => dispatch(actions.insuranceOfferStateChanged(insuranceOfferState)),
    deleteTicketInsurance: (csrfToken, confirm, ticketInsurance) => dispatch(actions.deleteTicketInsurance(dispatch, csrfToken, confirm, ticketInsurance)),
    hasInsuranceQuoteChanged: (hasInsuranceQuote) => dispatch(actions.hasInsuranceQuoteChanged(hasInsuranceQuote)),
    donationCustomChargeTypeChanged: (donationCustomChargeType) => dispatch(actions.donationCustomChargeTypeChanged(donationCustomChargeType)),
    ticketGroupsChanged: (ticketGroups) => dispatch(actions.ticketGroupsChanged(ticketGroups)),
    userContextChanged: (userContext) => dispatch(actions.userContextChanged(userContext)),
    fetchMembershipProducts: (confirm, userContext) => dispatch(actions.fetchMembershipProducts(confirm, userContext)),
    fetchMembershipPromoCode: (confirm, userContext, selectedMembershipProduct, calculatorRef) =>
      dispatch(actions.fetchMembershipPromoCode(confirm, userContext, selectedMembershipProduct, calculatorRef)),
    fetchPassPromoCode: (confirm, userContext, calculatorRef) =>
      dispatch(actions.fetchPassPromoCode(confirm, userContext, calculatorRef)),
    clearPromoRevealedTiers: (calculator, collections) =>
      dispatch(actions.clearPromoRevealedTiers(calculator, collections)),
    membershipProductsChanged: (membershipProducts) => dispatch(actions.membershipProductsChanged(membershipProducts)),
    selectedMembershipProductChanged: (selectedMembershipProduct) => dispatch(actions.selectedMembershipProductChanged(selectedMembershipProduct)),
    resaleListingsFetched: (resaleListings) => dispatch(actions.resaleListingsFetched(resaleListings)),
    resaleQuantityChanged: (listingId, quantity, ticketTypeName, listPriceCents, buyerTotalPerTicketCents, calculatorRef) =>
      dispatch(actions.resaleQuantityChanged(listingId, quantity, ticketTypeName, listPriceCents, buyerTotalPerTicketCents, calculatorRef))
  }
};

// Don't forget to actually use connect!
// Note that we don't export HelloWorld, but the redux "connected" version of it.
// See https://github.com/reactjs/react-redux/blob/master/docs/api.md#examples
export default connect(mapStateToProps, mapDispatchToProps)(WebOrderForm);
